// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // Esta apiUrl no se usa para firebase, se conserva para posibles APIS futuras
  apiURL: '',
  firebase: {
    apiKey: "AIzaSyDpXBA3ZVZS3uOkLM6q_J-W7ExLspl3kbs",
    authDomain: "qualisoluciones-web.firebaseapp.com",
    databaseURL: "https://qualisoluciones-web.firebaseio.com",
    projectId: "qualisoluciones-web",
    storageBucket: "qualisoluciones-web.appspot.com",
    messagingSenderId: "243963371684",
    appId: "1:243963371684:web:1c956ac5941cbe80d24631",
    measurementId: "G-JFK6VVJSH4"
  },
  APP_LOCALSTORAGE_PREFIX: 'EURE'
};

